// extracted by mini-css-extract-plugin
export default {"imageWrapper":"ZQ-z","hovered":"_Q-z","hoverImage":"aR-z","mainImage":"bR-z","imageNoBackground":"cR-z","fullSizeImage":"dR-z"};